<template>
    <div>
        <v-dialog v-model="show" persistent max-width="350">
            <v-card>
                <v-card-title class="headline">{{ heading }}</v-card-title>
                <v-card-text>{{ subHeading }}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        v-if="cancelButtonText"
                        :color="'red darken-1'"
                        flat
                        @click="$emit('onCancel')"
                    >{{ cancelButtonText }}</v-btn>

                    <v-btn
                        v-if="confirmButtonText"
                        :color="'green darken-1'"
                        @click="$emit('onSubmit')"
                        flat
                    >{{ confirmButtonText }}</v-btn>

                </v-card-actions>
         </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: 'ConfirmModal',
    props: {
        show: Boolean,
        heading: String,
        subHeading: String,
        confirmButtonText:String,
        cancelButtonText:String,
    },
}
</script>

<style lang="scss" scoped>

</style>
